import { render, staticRenderFns } from "./FormLoginSms.vue?vue&type=template&id=528c16a2&scoped=true&"
import script from "./FormLoginSms.vue?vue&type=script&lang=js&"
export * from "./FormLoginSms.vue?vue&type=script&lang=js&"
import style0 from "./FormLoginSms.vue?vue&type=style&index=0&id=528c16a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c16a2",
  null
  
)

export default component.exports